"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSignatureFieldValue = void 0;
const typing_1 = require("./typing");
const file_1 = require("./file");
const objects_1 = require("./objects");
const string_1 = require("./string");
const isSignatureFieldValue = (fieldValue) => {
    return (0, objects_1.isValidObjectValue)(fieldValue, {
        drawing: (0, typing_1.Optional)(file_1.isFileFieldValue),
        text: (0, typing_1.Optional)(string_1.isNullableStringValue),
        image_base64: (0, typing_1.Optional)(string_1.isNullableStringValue),
    }, true);
};
exports.isSignatureFieldValue = isSignatureFieldValue;
